function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import forEach from 'lodash/forEach';
import flowFP from 'lodash/fp/flow';
import groupByFP from 'lodash/fp/groupBy';
import mergeFP from 'lodash/fp/merge';
import orderByFP from 'lodash/fp/orderBy';
import partitionFP from 'lodash/fp/partition';
import map from 'lodash/map';
import prettyBytes from 'pretty-bytes';
import T from 'prop-types';
import React from 'react';
import AssetIcon from '../../components/icon/common/AssetIcon';
import Icon from '../../components/icon/Icon';
import { getAddOnConfig } from '../../components/mapView/drawingManager/utilities';
import { IconWrapper } from '../../components/RightMenu/Product';
import { AMPLITUDE_EVENTS } from '../../constants/analytics';
import { BIM_FILE_EXT, FEATURE_PLAN_EXT, FILE_FORMAT } from '../../constants/asset';
import { ASSET_ICON_MAP, PRODUCT_TYPE } from '../../constants/product';
import text from '../../text';
import { amplitudeTrack } from '../../utilities';
import { client } from '../../utilities/api';
import { isAdministrator } from '../../utilities/user';
import classNames from 'classnames';
var iconMap = mergeFP(ASSET_ICON_MAP, {});
var SOFTWARE = {
    Revit: [
        'rcs',
        'rvt'
    ],
    ArchiCAD: [
        'pln'
    ],
    AutoCAD: [
        'dwg'
    ],
    SketchUp: [
        'skp'
    ],
    VectorWorks: [
        'vwx'
    ],
    Rhino: [
        '3dm',
        'ply'
    ]
};
var getTitleMessage = function(product, fileFormat, software) {
    var tripodType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    switch(fileFormat){
        case 'pointCloud3D':
            {
                var extraLabel = [
                    PRODUCT_TYPE.INTERIOR,
                    PRODUCT_TYPE.EXTERIOR
                ].includes(product.toLowerCase()) ? ' Tripod ' : '';
                if (software) {
                    return text('productPointCloud3DTitle', {
                        product: product,
                        software: software,
                        extraLabel: extraLabel
                    });
                } else {
                    return text('productGenericPointCloud3DTitle', {
                        product: product,
                        extraLabel: extraLabel
                    });
                }
            }
        case 'drawing2D':
            return "".concat(text('drawing2DTitle', {
                tripod: tripodType,
                software: software
            }));
        case 'bim3D':
            return "".concat(text('bim3DTitle', {
                tripod: tripodType,
                software: software
            }));
        case 'image':
            return text('image');
        case 'document':
            return text('document');
        case 'compressed':
            return text('compressed');
        default:
            return text('other');
    }
};
var getAssetType = function(productType) {
    return productType ? iconMap[productType] : '';
};
var getFileExtension = function(filename) {
    return filename && filename.split('.').pop();
};
var getProductType = function(filename) {
    var fileExtension = getFileExtension(filename);
    var regexTripod = RegExp("[-_.]?(?<product>Exterior|Interior)[-_.]", "i");
    var regexBim = RegExp("[-_.]?(?<product>((Exterior|Interior)[-_.]?BIM|BIM[-_.]?(Exterior|Interior)))[-_.]", "i");
    var matchBim = regexBim.exec(filename);
    if (matchBim && BIM_FILE_EXT.includes(fileExtension)) {
        var _matchTripod_groups, _matchTripod_groups1;
        var matchTripod = regexTripod.exec(filename);
        if (!matchTripod) {
            return [
                '',
                ''
            ];
        }
        // returns BIM_<Exterior|Interior> at index 0 to set group and tag appropriate icon
        return [
            "BIM_".concat((_matchTripod_groups = matchTripod.groups) === null || _matchTripod_groups === void 0 ? void 0 : _matchTripod_groups.product),
            (_matchTripod_groups1 = matchTripod.groups) === null || _matchTripod_groups1 === void 0 ? void 0 : _matchTripod_groups1.product
        ];
    }
    if (filename.match(/[-_.]?(Plan)[-_.]?/i) && FEATURE_PLAN_EXT.includes(fileExtension)) {
        var _matchTripod_groups2, _matchTripod_groups3;
        var matchTripod1 = regexTripod.exec(filename);
        if (!matchTripod1) {
            return [
                '',
                ''
            ];
        }
        // returns Twod_Plan_<Exterior|Interior> at index 0 to set group and tag appropriate icon
        return [
            "Twod_Plan_".concat((_matchTripod_groups2 = matchTripod1.groups) === null || _matchTripod_groups2 === void 0 ? void 0 : _matchTripod_groups2.product),
            (_matchTripod_groups3 = matchTripod1.groups) === null || _matchTripod_groups3 === void 0 ? void 0 : _matchTripod_groups3.product
        ];
    }
    var regexPointClound = RegExp("[-_.]?(?<product>Drone|Exterior|Interior|Aerial|Streetscape)[-_.]", "i");
    var matchToPointCloud = regexPointClound.exec(filename);
    if (matchToPointCloud) {
        var _matchToPointCloud_groups;
        return [
            (_matchToPointCloud_groups = matchToPointCloud.groups) === null || _matchToPointCloud_groups === void 0 ? void 0 : _matchToPointCloud_groups.product,
            ''
        ];
    }
    return [
        '',
        ''
    ];
};
var getFileGroupFromMap = function(extension, groupMap) {
    var format;
    forEach(groupMap, function(exts, key) {
        if (exts.includes(extension)) {
            format = key;
        }
    });
    return format;
};
var getExtensionFormat = function(extension) {
    return getFileGroupFromMap(extension, FILE_FORMAT);
};
var getExtensionSoftware = function(extension) {
    return getFileGroupFromMap(extension, SOFTWARE);
};
var setFileGrouping = function(filename) {
    return [
        getProductType(filename),
        getFileExtension(filename)
    ];
};
var downloadFile = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(projectId, assetId) {
        var data, link;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getJobAsset(projectId, assetId)
                    ];
                case 1:
                    data = _state.sent().data;
                    link = document.createElement('a');
                    link.download = true;
                    link.href = data;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadFile(projectId, assetId) {
        return _ref.apply(this, arguments);
    };
}();
var AssetIconWrapper = function(props) {
    var productType = (props === null || props === void 0 ? void 0 : props.productType) || '';
    var isSuperseded = (props === null || props === void 0 ? void 0 : props.isSuperseded) || false;
    var isAddOn = !!getAddOnConfig(productType.toLowerCase());
    if (isAddOn) {
        return /*#__PURE__*/ React.createElement(IconWrapper, {
            icon: productType.toLowerCase(),
            isActive: isSuperseded
        });
    }
    return /*#__PURE__*/ React.createElement(AssetIcon, {
        product: getAssetType(productType),
        classNames: classNames('overwrite-asset-icon-style', {
            superseded: isSuperseded
        }),
        roundedCorners: false
    });
};
AssetIconWrapper.propTypes = {
    productType: T.string,
    isSuperseded: T.bool
};
var ActivityAsset = function(props) {
    var projectId = props.projectId, assets = props.assets, onDelete = props.onDelete, currentUser = props.currentUser, isSuperseded = props.isSuperseded;
    var FILE_MANAGER = AMPLITUDE_EVENTS.FILE_MANAGER;
    var partitionGroups = flowFP([
        function(result) {
            return map(result, function(item) {
                var _setFileGrouping = _sliced_to_array(setFileGrouping(item.filename), 2), _setFileGrouping_ = _sliced_to_array(_setFileGrouping[0], 2), product = _setFileGrouping_[0], tripodType = _setFileGrouping_[1], fileExtension = _setFileGrouping[1];
                var fileFormat = getExtensionFormat(fileExtension);
                return _object_spread_props(_object_spread({}, item), {
                    product: product,
                    titleMessage: getTitleMessage(product, fileFormat, getExtensionSoftware(fileExtension), tripodType)
                });
            });
        },
        partitionFP('product')
    ])(assets);
    var handleClick = function(assetId) {
        return /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(event) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            event.preventDefault();
                            amplitudeTrack(FILE_MANAGER.EVENT, {
                                action: FILE_MANAGER.DOWNLOAD_INDIVIDUAL_FILES
                            });
                            return [
                                4,
                                downloadFile(projectId, assetId)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
    };
    return map(partitionGroups, function(group) {
        var groupedByTitle = flowFP([
            orderByFP('titleMessage', [
                'asc'
            ]),
            groupByFP('titleMessage')
        ])(group);
        return map(groupedByTitle, function(groupedAssets, groupKey) {
            var orderedGroupedAssets = orderByFP('filename', [
                'asc'
            ], groupedAssets);
            var groupRep = orderedGroupedAssets[0];
            return /*#__PURE__*/ React.createElement("div", {
                key: groupKey,
                className: "ActivityAsset"
            }, /*#__PURE__*/ React.createElement("div", {
                key: "".concat(groupKey, "-top"),
                className: "Top align-items-center"
            }, /*#__PURE__*/ React.createElement("div", {
                className: classNames('IconContainer mr-2', {
                    superseded: isSuperseded
                })
            }, /*#__PURE__*/ React.createElement(AssetIconWrapper, {
                productType: groupRep === null || groupRep === void 0 ? void 0 : groupRep.product,
                isSuperseded: isSuperseded
            })), /*#__PURE__*/ React.createElement("span", null, text('groupedAssetsHeading', {
                baseMsg: groupRep.titleMessage,
                toDownload: /*#__PURE__*/ React.createElement("strong", {
                    key: groupKey
                }, text('filesToDownload', {
                    filePlural: text('filesPlural', {
                        numberFiles: groupedAssets.length
                    })
                }))
            }))), /*#__PURE__*/ React.createElement("div", {
                key: "".concat(groupKey, "-bottom"),
                className: "Bottom"
            }, map(orderedGroupedAssets, function(item, i) {
                var _item_metadata;
                return /*#__PURE__*/ React.createElement("div", {
                    className: "Asset",
                    key: i
                }, /*#__PURE__*/ React.createElement("a", {
                    onClick: handleClick(item === null || item === void 0 ? void 0 : item.id),
                    href: "#"
                }, item === null || item === void 0 ? void 0 : item.filename), /*#__PURE__*/ React.createElement("span", {
                    className: "FileSize"
                }, prettyBytes((item === null || item === void 0 ? void 0 : (_item_metadata = item.metadata) === null || _item_metadata === void 0 ? void 0 : _item_metadata.size) || 1)), typeof (item === null || item === void 0 ? void 0 : item.metadata.merged) !== 'undefined' && /*#__PURE__*/ React.createElement("span", {
                    className: "Merged"
                }, "(", item.metadata.merged ? 'Merged' : 'Unmerged', ")"), isAdministrator(currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) && /*#__PURE__*/ React.createElement(Icon, {
                    onClick: function() {
                        return onDelete(item === null || item === void 0 ? void 0 : item.id);
                    },
                    icon: "cross"
                }));
            })));
        });
    });
};
ActivityAsset.propTypes = {
    jobId: T.number,
    assets: T.arrayOf(T.shape()),
    type: T.string
};
export default ActivityAsset;
